import React, { memo, useState, useEffect } from "react";
import "./productItem.css";
import { Link } from "react-router-dom";
import sourRaspberry from "../../assets/images/vape/sourRaspberry.webp";

import hand from "../../assets/images/tap.png";

const ProductItem = memo(({ product, bgColor, index }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [showHand, setShowHand] = useState(true);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = () => {
    setShowHand(false); // hide hand after first click
  };

  return (
    <div className="product-item group relative" onClick={handleClick}>
      <div className="item-wrapper relative">
        {/* --- Бейдж "NEW" в левом верхнем углу --- */}
        {product.isNew && <span className="product-new-badge">NEW</span>}

        {/* Rectangle background */}
        <div
          className="rectangle-background"
          style={{ backgroundColor: bgColor }}
          aria-hidden
        ></div>

        {/* --- Centered badge --- */}
        <div
          className="
            absolute top-1/2 left-1/2
            transform -translate-x-1/2 -translate-y-1/2
            z-20 opacity-0 group-hover:opacity-100
            text-center
          "
        >
          <span className="product-badge">{product.title}</span>
        </div>

        {/* Vape image */}
        <img
          src={product.vape}
          alt={product.title || "vape"}
          className={`vape-image animate-${product.animation}`}
        />

        {/* --- Hand tap hint --- */}
        {isMobile && index === 0 && showHand && (
          <img src={hand} alt="Tap to view" className="hand-hint" />
        )}
      </div>
    </div>
  );
});

export default ProductItem;
